import 'normalize.css';
import ReactDOM from 'react-dom/client';
import Layout from './layout';
import './app.less';
import './rpc';

const root = document.getElementById('root')!;

ReactDOM.createRoot(root).render(<Layout />);
